import type { ErrorSeverity } from '@/shared/types/error-action'

/**
 * Per-errorCode presentation overrides for the error toast. Severity defaults to
 * the HTTP status (5xx/network → error, 4xx → warning); a friendly title is
 * optional. Only list codes that need a tailored look; everything else falls back
 * to the defaults.
 */
export const ERROR_PRESENTATION: Record<string, { severity?: ErrorSeverity; title?: string }> = {
  SERVICE_UNAVAILABLE: { severity: 'error', title: 'Servicio temporalmente no disponible' },
  ACCESS_TOKEN_INVALID: { severity: 'warning', title: 'Tu sesión ya no es válida' },
  MFA_CODE_INVALID: { severity: 'warning', title: 'Código incorrecto' },
  CLIENT_DUPLICATE: { severity: 'warning', title: 'Cliente duplicado' },
  CLIENT_HAS_NEGOTIATIONS: { severity: 'warning', title: 'No se puede eliminar' }
}
